<template>
    <div>
        <b-modal
            v-model="showModal" 
            title="Novo Evento" 
            @shown="onModalShown"
            size="lg"
            centered
            hide-footer 
        >   

            <div v-if="salesConsultantName" class="d-flex align-items-center justify-content-between mb-3">
                <p class="mb-0"><strong>Criando evento para:</strong></p>

                <div class="d-flex align-items-center" :style="{ gap: '12px' }">
                    <el-avatar size="small">{{ salesConsultantName.charAt(0) }}</el-avatar>
                    <p class="mb-0">{{ salesConsultantName }}</p>
                </div>
            </div>

            <el-form 
                :model="payload" 
                ref="eventStoreForm" 
                label-position="top" 
                status-icon 
                :rules="rules"
            > 
                <el-row :gutter="12">
                    <!-- Data -->
                    <el-col>
                        <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                <el-button type="warning" plain circle :style="{ pointerEvents: 'none' }">
                                    <i class="el-icon-date"></i>
                                </el-button>
                                <h6 class="mb-0 font-weight-bold">Data do evento</h6>
                            </div>

                            <el-form-item prop="data" class="mb-0">
                                {{ mutatorDate }}
                            </el-form-item>
                        </div>
                    </el-col>

                    <!-- Titulo -->
                    <el-col>
                        <el-form-item prop="titulo">
                            <label>Titulo</label>
                            <el-input
                                v-model="payload.titulo" 
                                placeholder="Titulo do evento"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>
                    
                    <!-- Despesas -->
                    <el-col>
                         <el-form-item prop="despesas">
                            <label>Despesas</label>
                            <el-checkbox-group v-model="payload.despesas" size="small">
                                <el-checkbox-button 
                                    v-for="expense in expenses" 
                                    :label="expense.value" 
                                    :disabled="expense.value === 'ALMOCO'" 
                                    :key="expense.value"
                                >
                                    {{ expense.text }}
                                </el-checkbox-button>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>

                    <!-- Items das despezas -->
                    <el-col v-if="handleItemsExpenses" class="mb-3">
                        <div class="bg-light border rounded-lg p-2 d-flex align-items-center justify-content-between" :style="{ gap: '12px' }">
                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                <i class="el-icon-files"></i>
                                <h6 class="mb-0 font-weight-bold">Itens da despezas</h6>
                            </div>

                            <el-button
                                size="small"
                                @click.native.prevent="addItemForExpense()"
                            >
                                <i class="el-icon-plus"></i>
                                Novo item
                            </el-button>
                        </div>

                        <el-row 
                            v-for="(item_despesa, index) in payload.itens_despesa"
                            :key="item_despesa.fake_id"
                            :gutter="20"
                        >   
                            <div class="d-flex align-items-end" :style="{ gap: '12px', paddingInline: '20px', marginBottom: '12px' }">
                                <el-tag type="primary" size="small" class="rounded-circle mb-1">{{ index + 1 }}</el-tag>
                                <el-form-item 
                                    :prop="`itens_despesa.${index}.tipo`" 
                                    class="mb-0"
                                    :rules="[{ required: true, message: 'O tipo da despesa é obrigátorio', trigger: 'change' }]"
                                >
                                    <label>Tipo</label>
                                    <el-radio-group v-model="payload.itens_despesa[index].tipo" size="small">
                                        <el-radio-button
                                            v-for="item_des_tipo in [
                                                { value: 'PEDAGIO', text: 'Pedágio'},
                                                { value: 'ESTACIONAMENTO', text: 'Estacionamento'},
                                                { value: 'UBER', text: 'Uber'}
                                            ]" 
                                            :label="item_des_tipo.value" 
                                            :key="item_des_tipo.value"
                                        >
                                            {{ item_des_tipo.text }}
                                        </el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
    
                                <el-form-item 
                                    :prop="`itens_despesa.${index}.valor`" 
                                    class="mb-0"
                                    :rules="[{ required: true, message: 'O valor da despesa é obrigátorio', trigger: 'blur' }]"
                                >
                                    <label>Valor</label>
                                    <el-input
                                        v-model="payload.itens_despesa[index].valor" 
                                        size="small"
                                        placeholder="0,00"
                                        maxlength="250"
                                        suffix-icon="el-icon-money"
                                        v-mask="['#,##', '##,##', '###,##']"
                                        :maxlength="6"
                                    >
                                        <template slot="prepend">R$</template>
                                    </el-input>
                                </el-form-item>

                                <el-button
                                    size="small"
                                    plain
                                    type="danger"
                                    circle
                                    @click.native.prevent="handleRemoveItemExpense(item_despesa.fake_id)"
                                >
                                    <i class="el-icon-delete"></i>
                                </el-button>
                            </div>
                        </el-row>
                    </el-col>

                    <!-- Observacoes -->
                    <el-col :span="isAuthorized ? 12 : 24">
                        <el-form-item prop="obs">
                            <label>Observações</label>
                            <el-input
                                type="textarea"
                                v-model="payload.obs" 
                                placeholder="Observações sobre o evento"
                                maxlength="250"
                                show-word-limit
                                :rows="5"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Observacoes coord -->
                    <el-col v-if="isAuthorized" :span="12">
                        <el-form-item prop="obs_coordenacao">
                            <label>Observações Coordenação</label>
                            <el-input
                                type="textarea"
                                v-model="payload.obs_coordenacao" 
                                placeholder="Observações da coordenação sobre o evento"
                                maxlength="250"
                                show-word-limit
                                :rows="5"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    plain
                                    :disabled="isLoading"
                                    @click="onSubmit"
                                >
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                    Salvar
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </b-modal>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form, 
        FormItem,
        CheckboxGroup,
        CheckboxButton,
        RadioGroup,
        RadioButton,
        Tag,
        Drawer,
        Avatar
    } from "element-ui";

    // Utis
    import { formattedDiffDate } from "../../util/formatters";

    //Api
    import { AgendaApi } from "@/api/AgendaApi";

    const agendaApi = new AgendaApi();

    export default {
        data() {
            return {
                payload: {
                    data: "",
                    titulo: "",
                    obs: "",
                    despesas: [],
                    itens_despesa: [],
                    obs_coordenacao: "",
                    user_id: null
                },
                showModal: false,
                isLoading: false,
                rules: {
                    data: [
                        { required: true, message: 'A data é obrigatória' }
                    ],
                    titulo: [
                        { required: true, message: 'O Titulo é obrigatório' },
                    ],
                },
                expenses: [
                    { value: 'VIAGEM', text: 'Viagem' },
                    { value: 'HOSPEDAGEM', text: 'Hospedagem' },
                    { value: 'ALMOCO', text: 'Almoço' },
                    { value: 'JANTAR', text: 'Jantar' },
                ],
                salesConsultant: null
            }
        }, 
        methods: {
            onSubmit() {
                this.$refs.eventStoreForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;
                    
                    try {
                        await agendaApi.store(this.payload)

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Um novo evento foi criado!'
                        });

                        await this.fetch();
                    } catch (error) {
                        if (error?.response.status == 422) {
                            if (error?.response?.data.errors) {
                                error.response.data.errors.forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }
                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível criar o evento!'
                        });
                    } finally {
                        this.isLoading = false;
                        this.toggleModal();
                        this.resetForm();
                        this.$emit('created');
                    }
                })
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.eventStoreForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.eventStoreForm.resetFields();
            },
            addItemForExpense() {
                this.payload.itens_despesa.push({
                    fake_id: Date.now() + Math.random(),
                    tipo: "",
                    valor: "",
                })
            },
            handleRemoveItemExpense(id) {
                this.payload.itens_despesa =  this.payload.itens_despesa.filter(
                    item => item.id !== id
                );
            },
            formatCurrencyToApi(value) {
                if (!value) {
                    return null
                }

                return value
                    .replace(/\./g, '')
                    .replace(',', '.')
            },
            formattedDiffDate
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
            mutatorDate() {
                return this.formattedDiffDate(this.payload.data);
            },
            handleItemsExpenses() {
                return this.payload.despesas.includes("VIAGEM")
            },
            salesConsultantName() {
                if (this.salesConsultant == null) {
                    return null
                }

                return this.salesConsultant.split('-')[1].trim();
            },
        },
        watch: {
            "payload.itens_despesa"(_newValue) {
                this.payload.itens_despesa.map(item => ({
                    ...item,
                    valor: this.formatCurrencyToApi(item.valor)
                }));
            },
            "payload.user_id": {
                immediate: true,
                handler(newValue) {
                    if (newValue == null) {
                        this.payload.user_id =
                            this.$store.getters['user/getUserId'].toString()
                    }
                }
            }
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [CheckboxGroup.name]: CheckboxGroup,
            [CheckboxButton.name]: CheckboxButton,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Tag.name]: Tag,
            [Drawer.name]: Drawer,
            [Avatar.name]: Avatar
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/EventCreateModal.vue